<template>
    <!-- 拍卖预展-拍卖专场详情 -->
    <div class="page session-detail" v-loading.fullscreen.lock="isLoading" element-loading-text="数据正在加载中" >
        <topNav :showWater="showWater"></topNav>
        <Header :showWater="showWater"></Header>
        <columnNav :showWater="showWater"></columnNav>
        <!-- 广告 -->
        <div class="pw">
            <AdvImage :advCode="'lvvln1100'"></AdvImage>
        </div>
        <!-- 方块  进入直播间 -->
        <cubeLive v-if="organCode" :specialDetail="specialDetail" :specialCode="$route.params.id" :name="name" :labelList="label_list" :detailExtraInfo="detailExtraInfo" :organCode="organCode" :sessionCode="sessionCode" :daiPaiExtraInfo="daiPaiExtraInfo" :liveInfo="liveInfo" :showWater="showWater" :status="status" :vrInfo="vrInfo" :zxpUrl="zxpUrl" :onlinePerson="onlinePerson" :onlineUrl="onlineUrl" :havePdf="havePdf" :podDetailLink="podDetailLink" @onlineClick="onlineClick"></cubeLive>
        <!-- 表格头部 -->
        <div class="tabTitle">
            <div class="img-icon">
                <img
                    v-if="textShow"
                    @click="listShow"
                    src="@/assets/previewImg/more-green.png"
                    alt=""
                />
                <img
                    v-if="!textShow"
                    @click="listShow"
                    src="@/assets/previewImg/more-gray.png"
                    alt=""
                />
                <img
                    v-if="picShow"
                    @click="switcClick"
                    src="@/assets/previewImg/menu-green.png"
                    alt=""
                />
                <img
                    v-if="!picShow"
                    @click="switcClick"
                    src="@/assets/previewImg/menu-gray.png"
                    alt=""
                />
            </div>
            <!-- 排序 -->
            <div class="dataSort" ref="tu" @click="titSort" :class="{'discologre':$route.query.ord == 2 || $route.query.ord == 3}">
                <template v-if="$route.query.ord == 3">图录号↓</template>
                <template v-else>图录号↑</template>
            </div>
            <div class="dataSort" ref="gu" @click="guSort" v-if="status < 5" :class="{'discologre':$route.query.ord == 6 || $route.query.ord == 7}">
                <template v-if="$route.query.ord == 7">估价↓</template>
                <template v-else>估价↑</template>
            </div>
            <div
                class="dataSort"
                ref="jiaoP"
                @click="jiaoPSort"
                v-if="status == 5"
                :class="{'discologre':$route.query.ord == 4 || $route.query.ord == 5}"
            >
                <template v-if="$route.query.ord == 5">成交价↓</template>
                <template v-else>成交价↑</template>
            </div>
            <!-- 搜索框 -->
            <div class="select demo-input-suffix">
                LOT号
                <el-input
                    @change="iptClick"
                    size="mini"
                    placeholder="请输入内容"
                    suffix-icon="el-icon-search"
                    v-model="input4"
                >
                </el-input>
            </div>
            <!-- 多选 -->
            <div class="checkBox">
                <el-checkbox
                    label="超清大图"
                    @change="checkClick"
                    v-model="ifCheck"
                ></el-checkbox>
            </div>
            <div class="total">
                <div>
                    共<span class="total-green">{{
                        num ? Math.ceil(num / 48) : 0
                    }}</span
                    >页<span class="total-green">{{ num ? num : 0 }}</span
                    >条
                </div>
            </div>
        </div>
        <!-- <sessionTou @messClick="messClick" ref="showHide"></sessionTou> -->
        <!-- 表格 -->
        <div v-loading="isLoading">
        <template v-if="epeciaList.length">
        <tabSession
            ref="tabSess"
            @pagelimt="pagelimt"
            :status="status"
            :pageId="param.pageId"
            :num="num"
            :epeciaList="epeciaList"
            v-if="textShow"
        ></tabSession>
        <imgSession
            ref="imgSess"
            @pagelimt="pagelimt"
            :status="status"
            :pageId="param.pageId"
            :num="num"
            :epeciaList="epeciaList"
            :city="city"
            v-if="picShow"
        ></imgSession>
        </template>
        </div>
        <emptyPage v-if="!epeciaList.length && !isLoading"></emptyPage>
        <!-- 底部商标 -->
        <copyright :showWater="showWater"></copyright>
        <watermark v-if="showWater"></watermark>
         <el-dialog
            title="提示"
            :visible="showPop"
            width="20%"
            center>
            <span>{{msgTips}}</span>
            <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="closePop">确 定</el-button>
            </span>
        </el-dialog>
        <div class="vipBox" v-if="isVipBtnShow"  id="anchorSp">
            <div class="gotoVip">
                <div class="vipContent">
                    <div class="vipLogo">
                        <img :src="vipLogo" alt=""/>
                    </div>
                    <div class="vipDetail">
                        <div class="vipTitle">成为藏家会员查看成交价</div>
                        <div class="vipOpen" @click="gotoVip">立即开通<i></i></div>
                    </div>
                </div>
                <div class="vipClose" @click="vipClose"></div>
            </div>
        </div>
        <anchorBox></anchorBox>
    </div>
</template>

<script>
import Header from "@/components/common/header";
import topNav from "@/components/common/topNav";
import anchorBox from "@/components/common/anchorBox";
import columnNav from "@/components/common/columnNav";
import cubeLive from "@/views/auction/components/session/cubeLive";
import tabSession from "@/views/auction/components/session/tabSession";
import imgSession from "@/views/auction/components/session/imgSession";
import copyright from "@/components/common/copyright";
import emptyPage from "@/components/common/emptyPage";
import { speCia } from "@/api/spec";
import {onlineAuction,getMemType} from "@/api/auction";
import watermark from "@/components/common/watermark";
import {mapActions, mapGetters} from "vuex";
import {agencyarr,setBidClick} from "@/api/auction";
import AdvImage from "@/components/advert/advImage";
import {sendScData} from "@/utils/buriedPoint";

export default {
    name: "special_detail",
    data() {
        return {
            showPop:false,
            msgTips:'',
            showWater:this.$route.query.from ? true : false,
            input4: this.$route.query.lot || '',
            textShow: this.$route.query.type == 'text' || false,
            picShow: this.$route.query.type && this.$route.query.type == 'text' ? false : true,
            jumpVal: 1,
            loading:true,
            currentPage: 1,
            activeName: 5,
            ifCheck:this.$route.query.bigPic == 1 ? true :false,
            status: 0,
            selectList: [
                { type: 0, name: "图录号" },
                { type: 0, name: "估价" },
                { type: 0, name: "热门度" },
                // { type: 1, name: "LOT号" },
            ],
            value: "",
            checkList: ["同步拍", "图文直播"],
            tabHS: true,
            epeciaList: [],
            num: "",
            param: {
                specialCode: "", //拍卖会id
                showType: 0, //全部显示总条数
                pageId: this.$route.query.page || 1, //页码数
                lot:this.$route.query.lot || '',
                limit: 48, //每页的个数
                ord: this.$route.query.ord || 2, //排序
                isBigPic: Number(this.$route.query.bigPic) || 0, //超清大图
            },
            isLoading:true,
            name:'',
            label_list: [], //保证金数组
            detailExtraInfo: [], //情况
            daiPaiExtraInfo:[],
            liveInfo: {
                have_live:0,
                have_review:0,
                live_status:0,
                label_list:[]
            },

            organCode:'',
            sessionCode:'',
            city:'',
            vrInfo:{
                vrLink: "",
                vrModelId: 0,
                vrType: 0
            },
            zxpUrl:'',
            havePdf:'',
            podDetailLink:'',
            onlinePerson:0,
            vipLogo:require('../../assets/imgs/icon_vip.png'),
            isVipBtnShow:false,
            loginData:{},
            onlineUrl:'',
            haveResultPrice:0,
            specialDetail:null
        };
    },
    asyncData({ store,route }) {
        let params = {
            specialCode:route.params.id,
            page:route.query.page,
            // only_meta:1
        }
        return store.dispatch("pageSpecialDetail/getSpecialDetail", [params, () => {}]);
    },
    computed:{
        ...mapGetters({
            getIsLoadIng: "pageSpecialDetail/getIsLoadIng",
            getData: "pageSpecialDetail/getData",
        }),
    },
    mounted() {
        this.getSpeCia();
        window.scroll({ top: 0, left: 0 })
        let parmas = {
                specialCode:this.$route.params.id,
                page:this.$route.query.page,
                // only_meta:1
            }
            this.getSpecialDetail([parmas,()=>{
                this.filteData();
            }])
        // if (!this.getIsLoadIng){
        //     let parmas = {
        //         specialCode:this.$route.params.id,
        //         page:this.$route.query.page,
        //         // only_meta:1
        //     }
        //     this.getSpecialDetail([parmas,()=>{
        //         this.filteData();
        //     }])
        // }else{
        //     this.filteData();
        // }				
        window.addEventListener('scroll',this.windowScroll)
    },
    methods: {
        ...mapActions({
            getSpecialDetail:"pageSpecialDetail/getSpecialDetail"
        }),
        filteData(){
            let data = this.$store.state["pageSpecialDetail"]["data"]
            var that = this;
            this.specialDetail = data;
            console.log(data,'data')
            // if(!data.meta.title){
            //     this.$message({
            //         message:'该内容不存在～',
            //         onClose(){
            //             that.$router.push({
            //                 path:'/'
            //             })
            //         }
            //     });
            //     return false
            // }
            this.name = data.name;
            this.city = data.city;
            this.label_list = data.live_info.label_list;
            this.detailExtraInfo = data.detailExtraInfo;
            this.daiPaiExtraInfo = data.daiPaiExtraInfo;
            this.status = data.status;
            this.liveInfo = data.live_info;
            this.zxpUrl = data.zxpUrl
            this.havePdf = data.pod.havePdf
            this.podDetailLink = data.pod.podDetailLink
            // if(!data.dataList.length){
            //             this.showPop = true
            //             this.msgTips = '没有相关商品'
            //             this.isLoading = false
            //  }else{
            //             this.epeciaList = data.dataList;
            //             this.num = data.art_total;
            //             this.isLoading = false
            // }
            
            let meetingName = '';
            let organName = '';
            let auctionNum = ''
            this.detailExtraInfo.forEach((value) => {
                switch (value.type){
                    case 'company':
                        that.organCode = value.organCode;
                        organName = value.text
                        break
                    case 'session':
                        that.sessionCode = value.sessionCode
                        meetingName = value.text
                        break
                    case 'total':
                        auctionNum = parseInt(value.text)
                        break

                }
            });

            if(data.catalog_info_new&&data.catalog_info_new.length){
                let catalog = data.catalog_info_new[0];
                this.isShowOnline = true;
                this.onlineTitle = catalog.title;
                this.onlineUrl = catalog.link;
                this.onlinePerson=data.bid_click_num;
            }
            this.haveResultPrice=data.have_result_price;
            // alert(this.organCode)

            this.getMemInfo();

            let meta = data.meta;
            let head = document.getElementsByTagName('head');
            sendScData('auctionSpeciaPerformance',{
                the_auction_id:this.sessionCode,
                the_auction_name:meetingName,
                auction_company:organName,
                auction_specia_performance_id:this.$route.params.id,
                auction_specia_performance_name:this.name,
                auction_items_number:auctionNum,
                source:this.$route.query.fromlink&&this.$route.query.fromlink=='pdf'?'电子书':'其他'
            })
            document.title = meta.title
            if(!document.querySelector('meta[name=description]')){
                let meta2 = document.createElement('meta');
                meta2.name = 'description';
                meta2.content = meta.description || '';
                head[0].appendChild(meta2)
            }else{
                document.querySelector('meta[name=description]').setAttribute('content',meta.description || '')
            }
        },
        listShow() {
            if (this.textShow == false) {
                this.textShow = true;
                this.picShow = false;
            }
        },
        switcClick() {
            if (this.textShow == true) {
                this.textShow = false;
                this.picShow = true;
            }
        },
        // 图录号
        titSort() {
            //ord 2图录号升序  3图录号降序
            this.$router.push({
                name:'special_detail',
                query:{
                    ord:!this.$route.query.ord || this.$route.query.ord == 2 ? 3 : 2,
                    keyword: this.$route.query.lot || '', //关键字
                },
                parmas:{
                    id:this.$route.params.id
                }
            })

            // this.$refs.tu.classList.add("discologre");
            // this.param.ord == 2 ? (this.param.ord = 3) : (this.param.ord = 2);
            // //    添加类名
            // if (this.param.ord == 3) {
            //     this.$refs.tu.innerText = "图录号↓";
            // } else if (this.param.ord == 2) {
            //     this.$refs.tu.innerText = "图录号↑";
            // }
            // this.getSpeCia();
            // // 去除其他的绿色
            // if (this.status == 5) {
            //
            //     this.$refs.jiaoP.innerText = "成交价↑";
            //     this.$refs.jiaoP.classList.remove("discologre");
            // } else if (this.status < 5) {
            //     this.$refs.gu.classList.remove("discologre");
            //     this.$refs.gu.innerText = "估价↑";
            // }
        },
        guSort() {
            //6估价升序 7估价降序
            this.$router.push({
                name:'special_detail',
                query:{
                    ord:!this.$route.query.ord || this.$route.query.ord == 7 ? 6 : 7,
                    keyword: this.$route.query.lot || '', //关键字
                },
                parmas:{
                    id:this.$route.params.id
                }
            })
            // this.$refs.gu.classList.add("discologre");
            // this.param.ord == 6 ? (this.param.ord = 7) : (this.param.ord = 6);
            // //    添加类名
            // if (this.param.ord == 7) {
            //     this.$refs.gu.innerText = "估价↓";
            // } else if (this.param.ord == 6) {
            //     this.$refs.gu.innerText = "估价↑";
            // }
            // this.getSpeCia();
            // // 去除其他的绿色
            // this.$refs.tu.classList.remove("discologre");
            // this.$refs.tu.innerText = "图录号↑";
        },
        jiaoPSort() {
            //4成交价升序  5成交价降序
            this.$router.push({
                name:'special_detail',
                query:{
                    ord:!this.$route.query.ord || this.$route.query.ord == 5 ? 4 : 5,
                    keyword: this.$route.query.lot || '', //关键字
                },
                parmas:{
                    id:this.$route.params.id
                }
            })
            // this.$refs.jiaoP.classList.add("discologre");
            // this.param.ord == 4 ? (this.param.ord = 5) : (this.param.ord = 4);
            // //    添加类名
            // if (this.param.ord == 5) {
            //     this.$refs.jiaoP.innerText = "成交价↓";
            // } else if (this.param.ord == 4) {
            //     this.$refs.jiaoP.innerText = "成交价↑";
            // }
            // this.getSpeCia();
            // // 去除其他的绿色
            // this.$refs.tu.classList.remove("discologre");
            // this.$refs.tu.innerText = "图录号↑";
        },
        getMemInfo(){
            // let params={
            //     code: this.sessionCode,
            //     specialCode:this.$route.params.id,
            // }
            // onlineAuction(params).then((res)=>{
            //     let data=res.data;
            //     if(data.catalog&&data.catalog.length){
            //         let catalog=data.catalog[0];
            //         this.zxpUrl=catalog.link;
            //         this.onlinePerson=1232;
            //     }
            // });
            getMemType().then(res=>{
                if(res.code==0){
                    this.loginData=res.data;
                    if(this.status==5&&this.haveResultPrice&&(!(res.data.isMember==1&&res.data.memberStatus==2))){
                        this.isVipBtnShow=true;
												sendScData('vipBenefitsEntryPage',{
														current_page:'拍卖专场详情页'
												});
                    }else{
                        this.isVipBtnShow=false;
                    }
                }
            })
        },
        // 多选框
        checkClick(value) {
            if (value) {
                this.$router.push({
                    name:'special_detail',
                    query:{
                        bigPic:1,
                    },
                    parmas:{
                        id:this.$route.params.id
                    }
                })
            } else if (!value) {
                this.$router.push({
                    name:'special_detail',
                    query:{
                        bigPic:0,
                    },
                    parmas:{
                        id:this.$route.params.id
                    }
                })
            }
        },
        //输入框输入内容
        iptClick() {
            // this.iftabimg();
            // this.param.pageId = val;
            // this.getSpeCia();
            this.$router.push({
                name:'special_detail',
                query:{
                    lot:this.input4,
                },
                parmas:{
                    id:this.$route.params.id
                }
            })
        },
        // 子组件传回来的页码数方法
        pagelimt(val) {
            // this.param.pageId = val;
            // this.getSpeCia();
            this.$router.push({
                name:'special_detail',
                query:{
                    lot:this.input4,
                    page:val,
                    type:this.textShow ? 'text' : 'img',
                    bigPic:this.ifCheck ? '1':'0',
                    ord:this.$route.query.ord || 2,
                },
                parmas:{
                    id:this.$route.params.id
                }
            })
        },
        // 判断是否是表格 还是图片列表
        iftabimg() {
            this.param.pageId = 1;
            if (this.tabHS) {
                this.jumpVal = 1;
                this.currentPage = 1;
            } else if (!this.tabHS) {
                this.jumpVal = 1;
                this.currentPage = 1;
            }
        },
        closePop(){
            this.msgTips = ''
            this.showPop = false
        },
        // 拍品列表
        getSpeCia() {
            this.param.specialCode = this.$route.params.id;
            // this.param.lot = this.input4
            this.param.keyword = this.input4
            this.epeciaList = []
            // this.param.specialCode = "PZ0000116";
            speCia(this.param).then((res) => {
                this.loading = false
                if (res.code == 0) {
                    if(!res.data.list.length){
                        this.showPop = true
                        this.msgTips = '没有相关商品'
                        this.isLoading = false
                    }else{
                        this.epeciaList = res.data.list;
                        this.num = res.data.num;
                        this.isLoading = false
                    }
                  
                }
            });
        },
        gotoVip(){
            sendScData('clickVip',{
                current_page:'拍卖专场详情页',
                button_name:'成为藏家会员查看成交价'
            });
            if(this.loginData.isLogin==0){
                window.location.href = '//passport.artron.net/login?appId=1&redirect='+encodeURIComponent(window.location.href)
            }else{
                if(!(this.loginData.isMember==1&&this.loginData.memberStatus==2)){
                    window.location.href='https://member.artron.net/memCenter/collect?business_id=50001&source_page=6&sourceReferer='+encodeURIComponent(window.location.href);
                }
            }
        },
        vipClose(){
            this.isVipBtnShow=false;
        },
        onlineClick(){
            let params = {
                specialCode: this.$route.params.id,
            }
            setBidClick(params).then(res=>{
                if(res.code==0){
                    // this.onlinePerson = res.data.bid_click_num;
                }
            });
            setTimeout(()=>{
                window.open(this.onlineUrl,'_blank');
            },500)
        },
        windowScroll(){
            var pageHeight = document.documentElement.clientHeight || document.body.clientHeight,
                scrollTop = document.documentElement.scrollTop || document.body.scrollTop,
                anchorObj = document.getElementById('anchorSp'),
                foot = document.getElementsByClassName('copyright')[0];
            if(anchorObj){
                var footTop = foot.offsetTop;
                if ((pageHeight + scrollTop) >= footTop + 50) {
                    anchorObj.style.bottom= pageHeight + scrollTop - footTop + 50 + "px";
                } else {
                    anchorObj.style.bottom= "50px";
                }
            }

        },
    },
    beforeDestroy() {
        window.removeEventListener('scroll',this.windowScroll)
    },
    components: {
        topNav,
        Header,
        columnNav,
        cubeLive,
        tabSession,
        copyright,
        imgSession,
        emptyPage,
        watermark,
        anchorBox,
        AdvImage
    },
};
</script>

<style scoped lang="scss">
@import url("../../assets/css/reset.css");
.session-detail {
    min-width: 1180px;
    .vipBox{
        position: fixed;
        bottom: 50px;
        .gotoVip{
            width: 228px;
            height: 60px;
            background: #FFFFFF;
            box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.1000);
            border-radius: 0px 4px 4px 0px;
            border: 1px solid #F2F2F2;
            position: relative;
            padding: 10px;
            .vipContent{
                display: inline-flex;
            }
            .vipLogo{
                width: 40px;
                height: 40px;
                background: linear-gradient(180deg, #E8C690 0%, #CD9457 100%);
                border-radius: 4px;
                margin-right: 8px;
                img{
                    width: 28px;
                    height: 28px;
                    object-fit: contain;
                    margin-top: 6px;
                    margin-left: 6px;
                }
            }
            .vipTitle{
                height: 20px;
                font-size: 12px;
                font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
                font-weight: bold;
                color: #262626;
                line-height: 20px;
            }
            .vipOpen{
                height: 20px;
                font-size: 12px;
                font-family: MicrosoftYaHei;
                color: #262626;
                line-height: 20px;
                cursor: pointer;
                &:hover{
                    text-decoration: underline;
                }
                i{
                    display: inline-block;
                    width: 10px;
                    height: 10px;
                    background: url(../../assets/imgs/icon_arrowright.png) no-repeat center center;
                    background-size: 100% 100%;
                    margin-left: 4px;
                }
            }
            .vipClose{
                position: absolute;
                top: 10px;
                right: 10px;
                background: url(../../assets/imgs/icon_close.png) no-repeat center center;
                background-size: 100% 100%;
                width: 9px;
                height: 9px;
                cursor: pointer;
                &:hover{
                    background: url(../../assets/imgs/icon_closehover.png) no-repeat center center;
                    background-size: 100% 100%;
                }
            }

        }
    }

}
// 面包屑样式
.breaCrumbs {
    width: 1180px;
    margin: auto;
}
/*拍卖结果*/
.tabTitle {
    width: 1180px;
    height: 60px;
    margin: 30px auto 18px;
    background: #fafafa;
    padding: 0px 20px;
    border: 1px solid #d9d9d9;
    line-height: 60px;
    display: flex;
    box-sizing: border-box;
    // 图标
    .img-icon {
        img {
            margin-right: 41px;
        }
        img:hover {
            cursor: pointer;
        }
    }
    // 日期升序降序
    .dataSort {
        padding: 0px 20px;
        font-size: 14px;
        font-family: MicrosoftYaHei;
        color: #262626;
    }
    .dataSort:hover {
        cursor: pointer;
    }
    .discologre {
        color: #329d15;
    }
    .checkBox{margin-left: 20px;}
    /deep/ .el-input__inner {
        height: 24px;
    }
    /deep/ .el-input {
        width: 180px;
        margin-left: 10px;
    }
    /deep/ .el-input__icon {
        line-height: 60px;
    }
    /deep/ .el-select-dropdown__item {
        // scroll: none;
        font-size: 14px;
        font-family: MicrosoftYaHei;
        color: #595959;
        line-height: 22px;
        text-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
    }
    /deep/ .el-scrollbar__wrap {
        overflow-y: hidden !important;
        overflow: hidden !important;
    }
    /deep/ .el-select-dropdown__item.selected {
        font-size: 14px;
        font-family: MicrosoftYaHei;
        color: #329d15;
        line-height: 22px;
        text-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
    }
    /deep/ .hover {
        font-size: 14px;
        font-family: MicrosoftYaHei;
        color: #329d15;
        line-height: 22px;
        text-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
    }
    // 多选框的样式
    /deep/ .el-checkbox-group {
        margin-left: 20px;
    }
    .total {
        font-size: 14px;
        font-family: MicrosoftYaHei;
        color: #595959;
        flex: 1;
        text-align: right;
        // a: right;
        .total-green {
            display: inline-block;
            margin: 0px 3px;
            color: #329d15;
        }
    }
}
/deep/.el-button--primary{background-color: #329d15}
/deep/.el-dialog__body{text-align: center;}
// 多选框样式
/deep/ .is-checked .el-checkbox__label {
    color: #329d15 !important;
}
/deep/ .is-checked .el-checkbox__inner {
    background-color: #329d15 !important;
    border-color: #329d15 !important;
}
/deep/ .el-checkbox__inner {
    border-color: #dcdfe6;
}
/deep/ .el-checkbox__inner:hover {
    border-color: #dcdfe6;
}
// 输入框样式
/deep/ .el-input__inner {
    border-color: #dcdfe6;
}
/deep/ .el-input__inner:hover {
    border-color: #329d15;
}
//.imgSess {
//    width: 1180px;
//    margin: auto;
//}
//// 图文列表样式
//.img-outbox {
//    display: flex;
//    justify-content: space-between;
//    align-items: center;
//    flex-wrap: wrap;
//
//    .img-item {
//        width: 580px;
//        height: 280px;
//        // background-color: lightblue;
//        margin-bottom: 20px;
//        display: flex;
//        border-radius: 4px;
//        .sessimg-left {
//            width: 50%;
//            height: 100%;
//            position: relative;
//            overflow: hidden;
//            border-radius: 4px 0 0 4px;
//            img {
//                width: 100%;
//                height: 100%;
//                object-fit: cover;
//            }
//            .iconSess {
//                width: 40px;
//                height: 40px;
//                position: absolute;
//                bottom: 10px;
//                right: 10px;
//            }
//        }
//        .sessimg-right {
//            // margin: 20px;
//            width: 50%;
//            border-radius: 0px 4px 4px 0px;
//            height: 100%;
//            border-top: 1px solid #d9d9d9;
//            border-right: 1px solid #d9d9d9;
//            border-bottom: 1px solid #d9d9d9;
//            box-sizing: border-box;
//            .sessimg-title {
//                font-size: 18px;
//                font-family: MicrosoftYaHei;
//                color: #262626;
//                padding: 20px;
//            }
//
//            .sessimg-sum {
//                // margin: 20px 0px;
//                .sum-item {
//                    display: flex;
//                    justify-content: space-between;
//                    span {
//                        display: inline-block;
//                        margin-bottom: 5px;
//                    }
//                    .tit {
//                        width: 68px;
//                        font-size: 14px;
//                        font-family: MicrosoftYaHei;
//                        color: #8c8c8c;
//
//                        overflow: hidden;
//                        text-overflow: ellipsis;
//                        white-space: nowrap;
//                    }
//                    .cont {
//                        width: calc(100% - 80px);
//                        font-size: 14px;
//                        font-family: MicrosoftYaHei;
//                        color: #262626;
//                    }
//                    .sessimg-red {
//                        color: #f5222d;
//                    }
//                }
//            }
//        }
//    }
//}
//
// 分页样式
//.paging {
//    width: 1180px;
//    margin: 40px auto 20px;
//    display: flex;
//    align-items: center;
//    justify-content: center;
//    .el-pagination {
//        display: inline-block;
//        text-align: center;
//        button {
//            padding: 0 10px;
//            line-height: 28px;
//            border: 1px solid #bfbfbf;
//            border-radius: 4px;
//            background-color: transparent;
//            color: #262626;
//        }
//        .el-pager {
//            font-size: 0;
//            li {
//                padding: 0 10px;
//                line-height: 28px;
//                border: 1px solid #bfbfbf;
//                border-radius: 4px;
//                background-color: transparent;
//                transition: 0.2s all ease-in-out;
//                font-weight: normal;
//            }
//            li:hover,
//            .active,
//            .el-pagination.is-background .el-pager li:not(.disabled).active {
//                border-color: #329d15;
//                background-color: #eaf5e7;
//                color: #329d15;
//            }
//            .more {
//                border: 0;
//            }
//        }
//    }
//    .el-pagination.is-background .el-pager li:not(.disabled).active {
//        border-color: #329d15;
//        background-color: #eaf5e7;
//        color: #329d15;
//    }
//    .total {
//        font-size: 14px;
//        color: #595959;
//        margin: 0 20px 0 15px;
//        i {
//            color: #329d15;
//        }
//    }
//    .jumpBox {
//        display: inline-block;
//        line-height: 30px;
//        color: #595959;
//        font-size: 14px;
//        .inputJump {
//            width: 28px;
//            height: 28px;
//            border-radius: 4px;
//            border: 1px solid #bfbfbf;
//            text-align: center;
//            color: #595959;
//            margin: 0 2px;
//        }
//    }
//}
//tabSession {
//    width: 1180px;
//    margin: 0 auto;
//}
//// 列表
//.aucResult {
//    min-width: 1180px;
//    margin: 0 auto;
//    .resultColTit {
//        font-weight: bold;
//        font-size: 14px;
//        margin-bottom: 14px;
//        margin-left: 20px;
//        margin-right: 20px;
//    }
//    .name {
//        width: 108px;
//        margin-right: 10px;
//        white-space: nowrap;
//        overflow: hidden;
//        text-overflow: ellipsis;
//    }
//    .number {
//        width: 400px;
//        overflow: hidden;
//        text-overflow: ellipsis;
//        white-space: nowrap;
//    }
//    .price {
//        width: 100px;
//    }
//    .company {
//        width: 300px;
//        overflow: hidden;
//        text-overflow: ellipsis;
//        white-space: nowrap;
//    }
//    /deep/.el-collapse {
//        border-bottom: 0;
//    }
//    /deep/.el-collapse-item {
//        .flex {
//            width: 100%;
//            padding:0 20px;
//            transition: .2s background-color ease-in-out;
//        }
//        .flex:hover {
//            background-color: #eaf5e7;
//            cursor: pointer;
//        }
//    }
//    /deep/.el-collapse-item__header {
//        border: 0;
//        height: 50px;
//        line-height: 50px;
//        color: #262626;
//        display: block;
//    }
//    /deep/.el-collapse-item__arrow {
//        display: none;
//    }
//    a {
//        display: block;
//        overflow: hidden;
//        text-overflow:ellipsis;
//        transition: .2s color ease-in-out;
//    }
//    a:hover {
//        color: #329d15;
//    }
//    /deep/.el-collapse-item__wrap {
//        background-color: #eaf5e7;
//        border-bottom: 0;
//        .el-collapse-item__content {
//            padding-bottom: 0;
//        }
//        .sessionLink {
//            border-top: 1px solid #d9d9d9;
//            span {
//                width: 49%;
//                display: inline-block;
//                color: rgba(0, 0, 0, 0.85);
//                line-height: 22px;
//                font-size: 14px;
//                padding: 10px 0;
//            }
//            span:before {
//                width: 8px;
//                height: 8px;
//                background-color: #329d15;
//                display: inline-block;
//                content: "";
//                margin-right: 8px;
//                border-radius: 50%;
//            }
//            span:hover {
//                cursor: pointer;
//                color: #329d15;
//            }
//        }
//    }
//}
</style>